import { render, staticRenderFns } from "./TraxAccountGroupCrudForm.vue?vue&type=template&id=1fc053a2"
import script from "./TraxAccountGroupCrudForm.vue?vue&type=script&lang=js"
export * from "./TraxAccountGroupCrudForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports